import { useEffect, useMemo, useState } from "react";
import { useLanguage } from "@/context/LanguageContext";

export const useLocalPage = (rows, perPage = 10) => {
  const list = rows || [];
  const [page, setPage] = useState(1);
  const pages = Math.max(1, Math.ceil(list.length / perPage));

  useEffect(() => {
    if (page > pages) setPage(1);
  }, [page, pages]);

  const slice = useMemo(
    () => list.slice((page - 1) * perPage, page * perPage),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [rows, page, perPage]
  );

  return { page, pages, setPage, slice, total: list.length };
};

export const LocalPager = ({ page, pages, total, onPage, testId = "pager" }) => {
  const { t } = useLanguage();
  if (total <= 0) return null;
  return (
    <div data-testid={testId} className="mt-3 flex flex-wrap items-center justify-between gap-3 text-xs text-[#8A97AD]">
      <span data-testid={`${testId}-total`}>{total} {t("pager.records")}</span>
      <div className="flex items-center gap-2">
        <button
          data-testid={`${testId}-prev`}
          disabled={page <= 1}
          onClick={() => onPage(page - 1)}
          className="rounded-md border border-[#1D2637] px-3 py-2 transition-colors hover:text-white disabled:opacity-40"
        >
          {t("pager.prev")}
        </button>
        <span data-testid={`${testId}-label`} className="font-mono">{t("pager.page")} {page} / {pages}</span>
        <button
          data-testid={`${testId}-next`}
          disabled={page >= pages}
          onClick={() => onPage(page + 1)}
          className="rounded-md border border-[#1D2637] px-3 py-2 transition-colors hover:text-white disabled:opacity-40"
        >
          {t("pager.next")}
        </button>
      </div>
    </div>
  );
};
